<div [@stepNavigation]="stepAnimationState$ | async">
  <stb-modal
    [noPMargins]="true"
    [forceClickOnButtons]="!(isCurrentStepCancelable$ | async)"
    [rebrand]="true"
    [isShowing]="true"
    [large]="true"
    [header]="currentStepTitle$ | async"
    [cancelText]="(showActions$ | async) && shouldShowPreviousButton() ? (previousButtonText$ | async) : null"
    (cancelClick)="shouldShowPreviousButton() ? onPrevious() : close()"
    [cancelTrackId]="'steppableModal-backButton'"
    [primaryText]="(showActions$ | async) ? (nextButtonText$ | async) : null"
    (primaryClick)="onNext()"
    [primaryTrackId]="'steppableModal-nextButton'"
    [isLoading]="loading$ | async"
    [primaryButtonDisabled]="loading$ | async"
    [cancelButtonDisabled]="loading$ | async"
  >
    <div #resetFocus>
      <ng-container #content></ng-container>
    </div>
  </stb-modal>
</div>
